import { AFRICAN_COUNTRIES, countryDialCodes, indianRegionMap } from "@/context/countries";

// Re-export storage helpers so existing `@/context/ip.utils` imports keep working.
// Prefer `@/context/ip.storage.utils` for new/light-only consumers to avoid
// pulling `countries.ts` into chunks that do not need AWS header enrichment.
export { fetchIpInfoData, getIpJSONData } from "@/context/ip.storage.utils";

const IP_STATIC_DATA = {
  city: "", // Delhi
  country_name: "India",
  country_code: "IN",
  ip: "", // 14.194.154.234
  connection: {
    asn: "", // AS45820
    isp: "", // Tata Teleservices Limited -GSM Division
  },
  currency: {},
  location: { calling_code: "91" },
  region_name: "", // New Delhi
  time_zone: {},
  zip: "", // 110001
};

export const fetchAWSHeadersCountryCode = async (
  isAfricaPage = false
) => {
  const headersCountryCode = await fetchHeadersCountryCode(isAfricaPage);

  let countryCode = headersCountryCode?.countryCode || "IN";
  let countryName = headersCountryCode?.countryName || "India";

  if (
    isAfricaPage &&
    !AFRICAN_COUNTRIES.map(({ countryCode }) => countryCode).includes(
      countryCode
    )
  ) {
    countryCode = "DZ";
    countryName = "Algeria";
  }

  let calling_code =
    countryDialCodes[countryCode]?.mobileCode ||
    IP_STATIC_DATA.location.calling_code;

  let regionName = "";
  if(countryCode == "IN"){
    regionName = indianRegionMap[headersCountryCode?.region] || headersCountryCode?.regionName || IP_STATIC_DATA.region_name;
  } else {
    regionName = headersCountryCode?.regionName || IP_STATIC_DATA.region_name;
  }

  IP_STATIC_DATA.city = headersCountryCode?.city || IP_STATIC_DATA.city;
  IP_STATIC_DATA.country_name = countryName;
  IP_STATIC_DATA.country_code = countryCode;
  IP_STATIC_DATA.location.calling_code = calling_code;
  IP_STATIC_DATA.region_name = regionName;
  IP_STATIC_DATA.zip = headersCountryCode?.postalCode || IP_STATIC_DATA.zip;

  const ipInfoData = JSON.parse(localStorage.getItem("ipDataStore_main"));

  if (
    ipInfoData &&
    ipInfoData?.country_code == IP_STATIC_DATA.country_code &&
    ipInfoData?.city == IP_STATIC_DATA.city &&
    ipInfoData?.region_name == IP_STATIC_DATA.region_name &&
    ipInfoData?.zip == IP_STATIC_DATA.zip
  ) {
    IP_STATIC_DATA.ip = ipInfoData?.ip || "";
    IP_STATIC_DATA.connection.asn = ipInfoData?.connection?.asn || "";
    IP_STATIC_DATA.connection.isp = ipInfoData?.connection?.isp || "";
  }

  localStorage.setItem("ipDataStore_main", JSON.stringify(IP_STATIC_DATA));

  return IP_STATIC_DATA;
};

async function fetchHeadersCountryCode(isAfricaPage = false) {
  try {
    const headersCountryCode = await fetch(
      "/api/country-code?isAfricaPage=" + isAfricaPage
    );
    const headersJsonData = await headersCountryCode.json();

    localStorage.setItem("cloudfrontLog", JSON.stringify(headersJsonData))

    return headersJsonData;
  } catch (e) {
    return { error: e };
  }
}
